/**
 * Hide cart button counter when count is 0
 */
jQuery(document).ready(function ($) {
	function toggleCartCounterVisibility() {
		const $counter = $('.js-cart-button-count');

		if ($counter.length) {
			// Check both text content and data attribute for the count
			let count = parseInt($counter.text()) || 0;

			// Fallback to data attribute if text is not yet updated
			if (count === 0 && $counter.attr('data-cart-count')) {
				count = parseInt($counter.attr('data-cart-count')) || 0;
			}

			if (count === 0) {
				$counter.css('display', 'none');
			} else {
				$counter.css('display', 'flex');
			}
		}
	}

	// Run on page load with a small delay to ensure DOM is fully ready
	toggleCartCounterVisibility();
	setTimeout(toggleCartCounterVisibility, 50);

	// Watch for changes in the counter element
	const observer = new MutationObserver(function () {
		toggleCartCounterVisibility();
	});

	// Start observing the counter element if it exists
	const counterElement = document.querySelector('.js-cart-button-count');
	if (counterElement) {
		observer.observe(counterElement, {
			childList: true,
			characterData: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['data-cart-count']
		});
	}

	// Also update when cart is modified or fragments are loaded
	$(document.body).on('added_to_cart removed_from_cart wc_fragments_refreshed wc_fragments_loaded', function () {
		// Small delay to ensure the counter has been updated
		setTimeout(toggleCartCounterVisibility, 100);
	});
});
